
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tiktok-products-trends",
      function () {
        return require("private-next-pages/tiktok-products-trends/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tiktok-products-trends"])
      });
    }
  